import React from "react";

export default function About() {
  return (
    <div className="pt-32 pb-24 min-h-screen" data-testid="about-page">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <p className="overline mb-4">Our Story</p>
        <h1 className="font-display text-5xl md:text-7xl font-light text-white tracking-tighter leading-[0.95]">
          From Lagos<br/>to the World.
        </h1>
        <img src="https://images.unsplash.com/photo-1612659513025-fe37f67574d6" alt="DaviDÉ" className="w-full h-[70vh] object-cover my-16" />
        <div className="space-y-8 text-white/80 leading-relaxed text-lg">
          <p>
            DaviDÉ Global Fashion was born from a simple belief: that the patterns, fabrics, and craftsmanship of Africa belong on every stage in the world. From Lagos studios where master tailors stitch by hand, to indigo vats in Abeokuta where Adire is dyed under the open sun, every piece carries the fingerprints of a people who have always wrapped identity in cloth.
          </p>
          <p>
            We work directly with cooperatives of pattern-makers and dyers, ensuring fair pay and creative credit for the artisans whose names rarely appear on luxury labels. Each Ankara strip you wear, each crimson edition you collect, every gold-trimmed bucket hat — they're a quiet rebellion against fashion that forgets where it came from.
          </p>
          <p>
            DaviDÉ stands for <em>boldness, heritage, and joy</em>. We design for those who walk into rooms knowing exactly who they are.
          </p>
          <p className="font-display text-2xl text-[var(--davide-gold)]">— DaviDÉ, Founder</p>
        </div>
      </div>
    </div>
  );
}
